import { Component } from "@angular/core";
import { Platform, NavParams, ViewController } from "ionic-angular";
import { SummaryServiceProvider } from "../../../../providers/wh/summary-service";

@Component({
  selector: "change-timing-cp-modal",
  templateUrl: "change-timing-cp-modal.html",
  providers: [SummaryServiceProvider]
})
export class ChangeTimingCpModalComponent {
  text: string;
  data;
  daysList;
  timeTextArabic;
  timeTextEnglish;
  startTime: any;
  endTime: any;
  selectedDayList: any;
  workingHours: any;
  isClosed: any;
  timeUpdated: any;
  isSpecial: any;
  isOpenWholeDay: any;

  constructor(
    public platform: Platform,
    public params: NavParams,
    public summaryService: SummaryServiceProvider,
    public viewCtrl: ViewController
  ) {
    this.text = "Hello World";
    this.data = this.params.get("data");
    this.timeTextEnglish = this.data.timeText.english || "";
    this.timeTextArabic = this.data.timeText.arabic || "";
    this.workingHours = this.data.workingHours;
    this.daysList = [
      { id: "0", name: "All Days" },
      { id: "1", name: "Sunday" },
      { id: "2", name: "Monday" },
      { id: "3", name: "Tuesday" },
      { id: "4", name: "Wednesday" },
      { id: "5", name: "Thrusday" },
      { id: "6", name: "Friday" },
      { id: "7", name: "Saturday" }
    ];
  }

  addTime() {
    var startHour;
    var startMin;
    var endHour;
    var endMin;
    var format;

    if (this.selectedDayList) {
      var dayFilter = this.daysList.filter(
        ele => ele.name === this.selectedDayList
      );
      if (this.startTime && this.endTime) {
        var splitStringStartTime = this.startTime.split(":");
        startHour = splitStringStartTime[0];
        startMin = splitStringStartTime[1];

        var splitStringEndTime = this.endTime.split(":");
        endHour = splitStringEndTime[0];
        endMin = splitStringEndTime[1];

        format = `${this.selectedDayList} ${this.startTime} ${this.endTime}`;
      }

      if (this.isOpenWholeDay) {
        this.startTime = "00:00";
        this.endTime = "23:59";
        startHour = "00";
        startMin = "00";
        endHour = "23";
        endMin = "59";
        format = `${this.selectedDayList} ${this.startTime} ${this.endTime}`;
      }

      if (this.isClosed) {
        format = `${this.selectedDayList} Closed`;
        startHour = 0;
        startMin = 0;
        endHour = 0;
        endMin = 0;
      }
      var isSpecial1 = 0;
      if (this.isSpecial) {
        isSpecial1 = 1;
        format += " Special";
      }
      var dateObject: any = {};
      dateObject.weekNumber = dayFilter[0].id;
      dateObject.weekString = dayFilter[0].name;
      dateObject.startTime = startHour;
      dateObject.startMinute = startMin;
      dateObject.endTime = endHour;
      dateObject.endMinute = endMin;
      dateObject.format = format;
      dateObject.isSpecial = isSpecial1;

      this.workingHours.push(dateObject);
      this.timeUpdated = true;
    } else {
      console.log("No Date Object Selected");
    }
  }

  decTime(item) {
    var index = this.workingHours.indexOf(item);
    this.workingHours.splice(index, 1);
    if (item.id == null) {
      return;
    }
    var id = [item.id];
    this.summaryService.deleteWorkingTiming(id).then(res => {});
  }

  saveTimings(id) {
    if (this.timeUpdated) {
      var remarks =
        '{"workHoursEntities":' +
        JSON.stringify(JSON.stringify(this.workingHours)) +
        "}";
      if (id) {
        this.summaryService.patchCPTimings(id, remarks).then(res => {
          this.timeUpdated = false;
          this.viewCtrl.dismiss(true);
        });
      }
    }
  }

  dismiss() {
    this.viewCtrl.dismiss(true);
  }
}



// WEBPACK FOOTER //
// ./src/pages/backoffice/collecion-points/change-timing-cp-modal/change-timing-cp-modal.ts